<template>
  <div class="w-100">
    <div class="alert alert-warning alert-dismissible fade show" role="alert">
      <span v-if="msg == 'dayTransLimit'">
        {{ this.$t("messages.dayTransLimit", { limit: limit }) }}</span
      >
      <span v-else-if="msg == 'monthTransLimit'">
        {{ this.$t("messages.monthTransLimit", { limit: limit }) }}</span
      >
      <span v-else-if="msg == 'dayAmountLimit'">
        {{ this.$t("messages.dayAmountLimit", { limit: limit }) }}</span
      >
      <span v-else-if="msg == 'monthAmountLimit'">
        {{ this.$t("messages.monthAmountLimit", { limit: limit }) }}</span
      >
      <span v-else-if="msg == 'minAmount'">
        {{ this.$t("messages.minAmount", { limit: limit }) }}</span
      >
      <span v-else-if="msg == 'Invalid Phone Number'">
        {{ this.$t("messages.invalidPhone", { limit: limit }) }}
      </span>
      <span v-else> {{ msg }}</span>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    msg: String,
    limit: Number,
  },
};
</script>
